import { setRegisteredData } from "./registered-data";

$('.winner-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    setRegisteredData(data, 'section#winner');

    // page swap
    $('section#winner .page').prop('hidden', true);
    $('section#winner .page-thank-you').prop('hidden', false);

    // modal (uncomment if you need a modal instead of page swap)
    //$('#modal-form-winner').modal('show');
});

$('.winner-form').on('submit-error', function(event, xhr) {
    event.preventDefault();
    if (xhr.status == 410) {
        alert('Formularz wygasł.');
    }
});

$('[name="noPesel"]').on('change', function() {
    $('[name="pesel"]', this.form.elements).prop('disabled', $(this).prop('checked'));
    let fields = [
        '[name="street"]',
        '[name="streetNr"]',
        '[name="flatNr"]',
        '[name="zipCode"]',
        '[name="city"]',
    ];
    $(fields.join(', '), this.form.elements).closest('.form-group').prop('disabled', !$(this).prop('checked'));
}).trigger('change');